export enum RecipeType {
  ORIGINAL = 'original',
  VARIANT = 'variant',
}

export enum RecipeTypeClassification {
  PUBLIC = 'PUBLIC',
  DEMOKIT = 'DEMOKIT',
  PRIVATE = 'PRIVATE',
}